/**
 * Quote cannot be generated without a positive agreed price per service line.
 */

export function basicQuotesHaveLinePriceDefined(rows: unknown[] | null | undefined): boolean {
  if (!Array.isArray(rows) || rows.length === 0) return false;
  return rows.every((row) => {
    const r = row as { price?: unknown };
    const price = Number(String(r.price ?? "").replace(/,/g, ""));
    return Number.isFinite(price) && price > 0;
  });
}

export function advancedQuotesHaveCostOverrideDefined(rows: unknown[] | null | undefined): boolean {
  if (!Array.isArray(rows) || rows.length === 0) return false;
  return rows.every((q) => {
    const sw = (q as { sectorWorkflow?: { costOverride?: { value?: unknown } } })?.sectorWorkflow;
    const v = Number(sw?.costOverride?.value ?? 0);
    return Number.isFinite(v) && v > 0;
  });
}

type QuoteCreateSliceLike = {
  stepQuote?: string;
  sectorWorkflow?: { costOverride?: { value?: unknown } | null } | null;
};

/** On the summary step, a finite agreed price greater than zero is required. */
export function advancedSummaryHasValidAgreedPrice(quoteCreate: QuoteCreateSliceLike | null | undefined): boolean {
  if (quoteCreate?.stepQuote !== "summary") {
    return true;
  }
  const v = Number(quoteCreate.sectorWorkflow?.costOverride?.value ?? 0);
  return Number.isFinite(v) && v > 0;
}

/** Used before closing the advanced quote modal: block only on summary without a valid price. */
export function shouldBlockAdvancedQuoteCloseForMissingPrice(quoteCreate: QuoteCreateSliceLike | null | undefined): boolean {
  if (quoteCreate?.stepQuote !== "summary") {
    return false;
  }
  return !advancedSummaryHasValidAgreedPrice(quoteCreate);
}

type QuoteDraftLike = {
  depositRequired?: boolean;
  depositAmount?: unknown;
  depositPercent?: unknown;
};

/** When "Require a deposit" is on, a positive amount or percent must be set (Redux reflects saved draft). */
export function isDepositRequirementSatisfied(quote: QuoteDraftLike | null | undefined): boolean {
  if (!quote?.depositRequired) {
    return true;
  }
  const amt = Number(quote.depositAmount ?? 0);
  if (Number.isFinite(amt) && amt > 0) {
    return true;
  }
  const pct = quote.depositPercent != null ? Number(quote.depositPercent) : NaN;
  return Number.isFinite(pct) && pct > 0;
}
